import babili from '../assets/babili.jpg'
import barkpoint from '../assets/barkpoint.jpg'
import travellogger from '../assets/travellogger.jpg'
export default [
  {
    id: 1,
    title: "Babili",
    description: " A Mobile Application designed to teach ESL adults and children English with fun interactive games.",
    image: babili,
    github: "https://github.com/CSL-CodingAsASecondLanguage/Babili",
    stack: [ { id: 1, title: 'React Native' }, { id: 2, title: 'Postgres' }, {id: 3, title: 'GoogleAPI'} ],
    url: "https://expo.io/@codingasasecondlanguage/babili"


  },
  {
    id: 2,
    title: "TravelLogger",
    description: "A web applicaton designed to preserve your memories whereever you are. Features Geolocation to track your location via Ip Address.",
    image: travellogger,
    github: "https://github.com/ABailey92/immersion-2020-10-mvp",
    stack: [ { id: 1, title: 'React' }, { id: 2, title: 'MYSQL' }, { id: 3, title: 'MapBoxGL' } ],
    url: null
  },
 {
    id: 3,
    title: "BarkPoint",
    description: "A web application designed to find entertainment for your favorite pup(s) with a fun personality assessment. ",
   image: barkpoint,
   github: "https://github.com/Bajamen/BarkPoint",
   stack: [ { id: 1, title: 'React' }, { id: 2, title: 'MongoDB' }, { id: 3, title: 'Material UI' } ],
   url: "https://possible-dream-296716.uc.r.appspot.com/"

  },
]
